class JitSourcingRelatedProducts extends HTMLElement {
  connectedCallback() {
    this.host = this.querySelector("[data-related-panel-host]");
    this.panel = this.querySelector(".jit-sourcing-v2__related-panel");
    this.empty = this.querySelector("[data-related-panel-empty]");
    this.templates = new Map(
      Array.from(this.querySelectorAll("[data-related-template]")).map((el) => [
        el.getAttribute("data-related-template"),
        el,
      ])
    );
    this.triggers = this.querySelectorAll("[data-related-trigger]");
    this.activeId = null;
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach((trigger) => {
      const id = trigger.getAttribute("data-related-id");
      if (!id) return;

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        this.show(id);
      });
      trigger.addEventListener("mouseenter", () => {
        if (window.matchMedia("(hover: hover)").matches) {
          this.show(id);
        }
      });
      trigger.addEventListener("focus", () => this.show(id));
    });
  }

  show(id) {
    if (!this.host) return;
    const template = this.templates.get(id);
    if (!template) return;

    this.activeId = id;
    this.triggers.forEach((trigger) => {
      trigger.classList.toggle("is-active", trigger.getAttribute("data-related-id") === id);
    });
    const clone = template.cloneNode(true);
    clone.removeAttribute("data-related-template");
    this.host.innerHTML = "";
    this.host.appendChild(clone);
    if (this.empty) this.empty.hidden = true;
    if (this.panel) {
      this.panel.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }
}

if (!customElements.get("jit-sourcing-related-products")) {
  customElements.define("jit-sourcing-related-products", JitSourcingRelatedProducts);
}
